import { Typography } from "@mui/material";
import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { StatusResult } from "../../types/types";
import styles from "./charts.module.css";

type SnapshotChartProps = {
  data: StatusResult;
};
const SnapshotChart = (props: SnapshotChartProps) => {
  const { data } = props;
    const chartData = data.mostRecentCheckValues.map((item) => ({
    name: item.siteLabel,
    dns: Number(item.dnsLookupTime),
    response: Number(item.responseTime),
  }));
  if( chartData && chartData.length === 0) {
    return <></>;
  }
  return (
    <>
      <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>Current Response Time</Typography>
      <ResponsiveContainer width={"80%"} height={300}>
        <BarChart
          data={chartData}
          width={500}
          height={300}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip content={<CustomTooltip />} />
          <Legend />
          <Bar dataKey="dns" stackId="a" fill="#007bff" />
          <Bar dataKey="response" stackId="a" fill="#fd7e14" />
        </BarChart>
      </ResponsiveContainer>
    </>
  );
};

const CustomTooltip = ({ active, payload, label }: any) => {
  if (active && payload && payload.length) {
    return (
      <Typography
        variant="caption"
        display="block"
        gutterBottom
        className={styles.tooltip}
      >
        <p className="label">
          DNS Look Up: <strong>{`${payload[0].payload.dns} ms`}</strong>{" "}
          Response Time: <strong>{`${payload[0].payload.response} ms`}</strong>
        </p>
        <p className="label">
          Location: <strong>{`${label}`}</strong>
        </p>
      </Typography>
    );
  }

  return null;
};

export default SnapshotChart;
